import { actions } from '../constants/login';
import * as actionTypes from '../../models/action/login';
import * as types from '../../models/pages/login';
import { string } from 'prop-types';

export function setCurrentPage(currentPage: string, recoveryPasswordToken?: string | null): actionTypes.ILoginSetCurrentPageAction {
    return {
        currentPage,
        recoveryPasswordToken,
        timestamp: Date.now(),
        type: actions.LOGIN_SETCURRENTPAGE
    };
}

export function setPageData(pageData: types.ILoginPageData): actionTypes.ILoginSetPageDataAction {
    return {
        pageData,
        timestamp: Date.now(),
        type: actions.LOGIN_SETPAGEDATA
    };
}

export function getPageData(callback?: any): actionTypes.ILoginGetPageDataAction {
    return {
        timestamp: Date.now(),
        type: actions.LOGIN_GETPAGEDATA,
        callback
    };
}

export function logOff(spinnerId?: string): actionTypes.ILogOff {
    return {
        timestamp: Date.now(),
        type: actions.LOGIN_LOGOFF,
        spinnerId
    };
}

export function AlmsLogOut(callback?: any): actionTypes.ILogOff {
    return {
        timestamp: Date.now(),
        type: actions.ALMS_LOGIN_LOGOUT,
        callback
    };
}

export function clickLoginForm(userName: string, password: string, loginCulture?: string, googleCaptchaToken?: string, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ILoginClickButtonAction {
    return {
        userName,
        password,
        loginCulture,
        spinnerId,
        googleCaptchaToken,
        spinnerType,
        timestamp: Date.now(),
        type: actions.LOGIN_CLICKLOGINFORM,
        params: { userName, password }
    };
}

export function clickExternalLogin(token: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: any): actionTypes.IExternalLoginAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.LOGIN_EXTERNALLOGIN,
        token,
        callback
    };
}

export function clickExternalLoginOBS(token: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: any): actionTypes.IExternalLoginObsAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.LOGIN_EXTERNALLOGINOBS,
        token,
        callback
    };
}

export function connectToAlms(spinnerId?: string, spinnerType?: 'get' | 'set', parameters?: any): actionTypes.IConnectToAlmsAction {
    return {
        spinnerId,
        spinnerType,
        parameters,
        timestamp: Date.now(),
        type: actions.LOGIN_TOALMS,
    };
}
export function connectToExamApp(spinnerId?: string, spinnerType?: 'get' | 'set', parameters?: any): actionTypes.IConnectToExamAppAction {
    return {
        spinnerId,
        spinnerType,
        parameters,
        timestamp: Date.now(),
        type: actions.LOGIN_TOEXAMAPP,
    };
}

export function clickEdevletLogin(token: string, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IEdevletLoginAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.LOGIN_EDEVLETLOGIN,
        token 
    };
}

export function resultLoginForm(resultData: types.ILoginResultData, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ILoginFormResultAction {
    return {
        timestamp: Date.now(),
        type: actions.LOGIN_RESULTLOGINCLICK,
        returnData: resultData,
        spinnerId,
        spinnerType
    };
}

// #region My forgot password action
export function myForgotPasswordGetAction(searchedUser: string, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IMyForgotPasswordGetAction {
    return {
        searchedUser,
        timestamp: Date.now(),
        type: actions.LOGIN_MY_FORGOT_PASSWORD_GET,
        spinnerId,
        spinnerType
    };
}

export function myForgotPasswordSetAction(myForgotPasswordData: { haveUser: boolean | null, isQuestion: string | null, passwordSecurtiyQuestion: string | null, userName: string | null } | null, currentPage: string, recoveryPasswordToken?: string, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IMyForgotPasswordSetAction {
    return {
        myForgotPasswordData,
        currentPage,
        timestamp: Date.now(),
        type: actions.LOGIN_MY_FORGOT_PASSWORD_SET,
        spinnerId,
        spinnerType
    };
}
// #endregion

// #region My Forgot Password Question Answer Actions
export function myForgotPasswordQuestionAnswerGetAction(searchedUser: string, typedText: string, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IMyForgotPasswordQuestionAnswerGetAction {
    return {
        searchedUser,
        typedText,
        timestamp: Date.now(),
        type: actions.LOGIN_MY_FORGOT_PASSWORD_QUESTION_ANSWER_GET,
        spinnerId,
        spinnerType
    };
}

export function myForgotPasswordQuestionAnswerSetAction(myForgotPasswordAnswerStatus: boolean, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IMyForgotPasswordQuestionAnswerSetAction {
    return {
        myForgotPasswordAnswerStatus,
        timestamp: Date.now(),
        type: actions.LOGIN_MY_FORGOT_PASSWORD_QUESTION_ANSWER_SET,
        spinnerId,
        spinnerType
    };
}
// #endregion

// #region My Forgot Reset Password Check Token Actions
export function myForgotPasswordCheckTokenGetAction(token: string): actionTypes.INewPasswordGetAction {
    return {
        token,
        timestamp: Date.now(),
        type: actions.LOGIN_RESET_PASSWORD_CHECK_TOKEN_GET
    };
}

export function myForgotPasswordCheckTokenSetAction(
    currentPage: string,
    expiredToken: boolean,
    newPasswordLoading: boolean,
    notFoundToken: boolean,
    alphaNumericLength: number,
    minPasswordLength: number,
    passwordStrength: string): actionTypes.INewPasswordSetAction {
    return {
        currentPage,
        expiredToken,
        newPasswordLoading,
        notFoundToken,
        alphaNumericLength,
        minPasswordLength,
        passwordStrength,
        timestamp: Date.now(),
        type: actions.LOGIN_RESET_PASSWORD_CHECK_TOKEN_SET
    };
}
// #endregion My Forgot Reset Password Check Token Actions


// #region My Forgot Password Save
export function myForgotPasswordSaveGetAction(password: string, token: string, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IMyForgotPasswordSaveGetAction {
    return {
        password,
        token,
        timestamp: Date.now(),
        type: actions.LOGIN_RESET_PASSWORD_SAVE_GET,
        spinnerId,
        spinnerType
    };
}

export function myForgotPasswordSaveSetAction(saveStatus: boolean, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IMyForgotPasswordSaveSetAction {
    return {
        saveStatus,
        timestamp: Date.now(),
        type: actions.LOGIN_RESET_PASSWORD_SAVE_SET,
        spinnerId,
        spinnerType
    };
}
// #endregion


export function getUserIdentitiy(): actionTypes.IGetUserIdentity {
    return {
        timestamp: Date.now(),
        type: actions.LOGIN_GETUSERIDENTITY
    };
}

export function setUserIdentitiy(identitiyData: types.IUserIdentity): actionTypes.ISetUserIdentity {
    return {
        timestamp: Date.now(),
        type: actions.LOGIN_SETUSERIDENTITY,
        userIdentityData: identitiyData
    };
}

export function checkVerificationCode(isForLogin: boolean, username: string, verificationCode: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void): actionTypes.ICheckVerificationCode {
    return {
        isForLogin,
        username,
        verificationCode,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.CHECK_VERIFICATION_CODE,
        callback
    };
}

export function verificateUser(username: string, token: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void): actionTypes.IVerificateUser {
    return {
        username,
        token,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.VERIFICATE_USER,
        callback
    };
}

export function SetVerificateUserMail(twoFactorAuthMailAddress: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void): actionTypes.ISetVerificateUserMail {
    return {
        twoFactorAuthMailAddress,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_VERIFICATE_USER_MAIL,
        callback
    };
}

export function SetLoginFormData( loginFormData: any, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void): actionTypes.ISetLoginFormData {
    return {
        loginFormData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_LOGIN_FORM_DATA,
        callback
    };
}

export function SetTwoFactorMethodError( errorMessage: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void): actionTypes.ISetTwoFactorErrorMessage {
    return {
        errorMessage,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_TWO_FACTOR_CODE_ERROR,
        callback
    };
}

export function setUseTimezone(timezone: string, spinnerId?: string, spinnerType?: 'get'|'set') {
    return {
        timezone,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_USE_TIMEZONE
    };
}